import { useEffect, useState } from 'react';
import { useParams, Navigate, useNavigate } from 'react-router-dom';
import PageHeader from '../../../components/owner/PageHeader';
import { usePanelToast } from '../../../context/PanelToastContext';
import SaasPlanForm from './SaasPlanForm';
import { fetchSaasPlanById, updateSaasPlan } from '../../../services/owner/subscriptionsApi';
import '../ownerPages.css';
import './subscriptions.css';

function EditSubscription() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = usePanelToast();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError('');
        const data = await fetchSaasPlanById(id);
        if (cancelled) return;
        if (!data) {
          setNotFound(true);
        } else {
          setPlan(data);
        }
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load plan');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  if (notFound) {
    return <Navigate to="/owner/packages" replace />;
  }

  const handleSubmit = async (form) => {
    try {
      setSaving(true);
      setError('');
      await updateSaasPlan(id, form);
      toast.showSaved('Package');
      navigate('/owner/packages');
    } catch (err) {
      setError(err.message || 'Failed to update package');
      toast.showError(err.message || 'Failed to update package');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <PageHeader
        title="Edit Subscription Package"
        subtitle={plan ? `Editing: ${plan.name}` : 'Loading package...'}
      />

      {loading && <p className="owner-placeholder-text owner-mb-16">Loading package...</p>}
      {error && <p className="owner-placeholder-text owner-mb-16" style={{ color: 'var(--owner-danger, #dc2626)' }}>{error}</p>}

      {plan && (
        <div className="owner-card rec-panel-card owner-panel-section subscription-form-card">
          <SaasPlanForm
            isEdit
            initialData={plan}
            submitLabel={saving ? 'Saving…' : 'Save Changes'}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/owner/packages')}
          />
        </div>
      )}
    </div>
  );
}

export default EditSubscription;
